// **Der Rahmen**: Navigation links (Marke, Abschnitte, Konto, Darstellung,
// Abmelden), rechts Kopf und Inhalt. Der Kopf gehört der Ansicht (PageHead).

import { useState, type ReactNode } from "react";
import { post } from "../api/client";
import type { Me } from "../api/types";
import { NAV } from "../router/routes";
import { Link, useLocation } from "../router/router";
import { HeadProvider } from "./page-head";
import { ThemeSwitch } from "./theme-switch";

/** Der Zwischenspeicher des Dashboards (views/dashboard) — er hält Mandantendaten. */
export const DASHBOARD_CACHE_KEY = "sc-pf-dashboard";

export async function logout(): Promise<void> {
  // Der Zwischenspeicher des Dashboards hält Mandantendaten — er geht mit.
  try { sessionStorage.removeItem(DASHBOARD_CACHE_KEY); } catch { /* privat */ }
  try { await post("/auth/logout"); } catch { /* egal */ }
  window.location.href = "/";
}

export function Shell({ me, children }: { me: Me; children: ReactNode }) {
  const { pathname } = useLocation();
  const [head, setHead] = useState<HTMLElement | null>(null);
  return (
    <div className="pf-page">
      <nav className="pf-nav" aria-label="Plattform">
        <div className="pf-nav__brand"><div className="pf-nav__mark" role="img" aria-label="SoluCoder" /><span className="pf-nav__sub">Plattform</span></div>
        <div className="pf-nav__group">
          {NAV.map(([href, label, match]) => (
            <Link key={href} className={`pf-nav__link${match(pathname) ? " pf-nav__link--active" : ""}`} to={href}>{label}</Link>
          ))}
        </div>
        <div className="pf-nav__foot">
          <span className="pf-nav__user">{me.name}<br />{me.email}</span>
          <ThemeSwitch />
          <button type="button" className="pf-btn pf-btn--ghost pf-btn--sm" onClick={() => void logout()}>Abmelden</button>
        </div>
      </nav>
      <main className="pf-main">
        <header className="pf-head" ref={setHead} />
        <HeadProvider element={head}>
          <div className="pf-outlet">{children}</div>
        </HeadProvider>
      </main>
    </div>
  );
}
